import React from 'react';
import { Form } from 'react-final-form';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import PasswordField from '../../../../../components/Fields/PasswordField';
import TextField from '../../../../../components/Fields/TextField';
import { validateLogin } from '../../validators';
import { useStyles } from './styles';

interface LoginProps {
  handleSubmit: (event: any) => void;
}
const LoginFormSura = ({ handleSubmit: onSubmit }: LoginProps) => {
  const classes = useStyles();

  return (
    <Grid item>
      <Box mb={3}>
        <Typography gutterBottom className={classes.leftTitle}>
          Iniciá sesión
        </Typography>
        <Typography className={classes.description}>
          Si sos cliente completá tus datos para iniciar sesión y autogestionate
          en un toque.
        </Typography>
      </Box>
      <Form
        onSubmit={onSubmit}
        validate={validateLogin}
        render={({ handleSubmit, hasValidationErrors }) => (
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <Typography className={classes.label} variant="body2">
                N° de documento
              </Typography>
              <TextField
                id="identification_number"
                name="identification_number"
                placeholder="Ingresá tu número de documento"
                type="number"
              />
            </Box>
            <Box mb={1}>
              <Typography className={classes.label} variant="body2">
                Contraseña
              </Typography>
              <PasswordField
                id="password"
                name="password"
                placeholder="Ingresá tu contraseña"
                type="password"
                inputProps={{
                  maxLength: 40,
                }}
              />
            </Box>
            <Box mb={4}>
              <Link
                className={classes.forgotPassword}
                component={RouterLink}
                to="/forgot-password"
                color="secondary"
                variant="h6"
              >
                Olvidé mi contraseña
              </Link>
            </Box>
            <Grid container direction="row" justify="center" spacing={3}>
              <Grid xs={12} sm={6} item>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  disabled={hasValidationErrors}
                >
                  Ingresar
                </Button>
              </Grid>
              <Grid xs={12} sm={6} item>
                <Button
                  component={RouterLink}
                  to="/sign-up"
                  variant="outlined"
                  color="secondary"
                  fullWidth
                >
                  Registrate
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      />
    </Grid>
  );
};

LoginFormSura.displayName = 'LoginFormSura';

export default LoginFormSura;
